import { buildCheckCartOrderItems } from '../../Cart/checkCartApi';
import { mapWebOrderTypeForApi } from './webOrderTypeUtils';

/** @typedef {import('./paymentCheckoutState').CheckoutPayload} CheckoutPayload */

/**
 * @param {CheckoutPayload} payload
 * @returns {'pickup' | 'delivery'}
 */
export function resolveFulfillmentType(payload) {
  return payload.form.fulfillmentType === 'pickup' ? 'pickup' : 'delivery';
}

/**
 * @param {CheckoutPayload} payload
 * @param {{
 *   cartTotal: number,
 *   discount: number,
 *   packagingFee: number,
 *   delivery: number,
 *   gstTax: number,
 *   grandTotal: number,
 * }} charges
 * @param {import('./paymentMethodUtils').PaymentMethodId} [paymentMethodId]
 */
export function buildCreateOrderRequest(payload, charges, paymentMethodId) {
  const fulfillmentType = resolveFulfillmentType(payload);

  const body = {
    orderItems: buildCheckCartOrderItems(payload.cartItems),
    orderType: mapWebOrderTypeForApi(fulfillmentType),
    coupons: payload.appliedCoupon?.code ?? null,
    instructions: String(payload.form.notes || '').trim() || '',
    discounts: null,
    subTotal: Number(charges.cartTotal),
    totalTax: Number(charges.gstTax),
    totalDiscount: Number(charges.discount),
    totalDeliveryCharge: Number(charges.delivery),
    totalPackagingCharge: Number(charges.packagingFee),
    totalAmount: Number(charges.grandTotal),
    distance: fulfillmentType === 'pickup' ? 0 : Number(payload.distanceKm) || 0,
    paymentMethod: mapPaymentMethodForApi(paymentMethodId),
    deferredStock: true,
  };

  if (fulfillmentType !== 'pickup') {
    body.addressID =
      payload.selectedAddressId != null && Number.isFinite(Number(payload.selectedAddressId))
        ? Number(payload.selectedAddressId)
        : null;
  }

  return body;
}

/**
 * @param {CheckoutPayload} payload
 * @returns {string | null}
 */
export function mapPaymentMethodForApi(methodId) {
  if (!methodId || methodId === 'all') return 'razorpay';
  const allowed = ['upi', 'card', 'netbanking', 'wallet'];
  return allowed.includes(methodId) ? methodId : 'razorpay';
}

/**
 * @param {CheckoutPayload} payload
 * @returns {string | null}
 */
export function validateCreateOrderPayload(payload) {
  if (resolveFulfillmentType(payload) === 'pickup') {
    return null;
  }
  if (payload.selectedAddressId == null || !Number.isFinite(Number(payload.selectedAddressId))) {
    return 'Select a saved address from checkout before paying. The kitchen needs a mapped address to place your order.';
  }
  return null;
}
